var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/helpers/utils.js",
    _this = this;

import React from 'react';
import { useTheme } from '../core/ThemeProvider';
import useDevice from '../core/hooks/useDevice';
export var resizeIcon = function resizeIcon(Icon) {
  var _Icon$type;

  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var _useDevice = useDevice(),
      isMobile = _useDevice.isMobile;

  var size = theme.listItem.sizeThumbnailIcon;
  var stroke = 'none';

  if (Icon !== null && Icon !== void 0 && (_Icon$type = Icon.type) !== null && _Icon$type !== void 0 && _Icon$type.name.includes('Arrow')) {
    if (isMobile) {
      size = theme.listItem.sizeArrowIconXS;
      stroke = theme.listItem.colorIcon;
    } else {
      size = theme.listItem.sizeArrowIcon;
    }
  }

  return /*#__PURE__*/React.createElement(Icon, {
    size: size,
    color: theme.listItem.colorIcon,
    stroke: stroke,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 10
    }
  });
};